import { render, staticRenderFns } from "./wecomGate.vue?vue&type=template&id=d1838404&scoped=true"
import script from "./wecomGate.vue?vue&type=script&lang=js"
export * from "./wecomGate.vue?vue&type=script&lang=js"
import style0 from "./wecomGate.vue?vue&type=style&index=0&id=d1838404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1838404",
  null
  
)

export default component.exports